import { serverHost } from "variables/serverdata";

// -----------------------
// Auth helper
// -----------------------
function getAuthToken() {
    try {
        const raw = localStorage.getItem("user");
        if (!raw) return localStorage.getItem("token");
        const parsed = JSON.parse(raw);
        return (
            parsed?.access_token ||
            parsed?.token ||
            parsed?.accessToken ||
            null
        );
    } catch {
        return localStorage.getItem("token");
    }
}

// -----------------------
// Create Extension
// -----------------------
export async function createExtension(payload) {
    const token = getAuthToken();
    if (!token) throw new Error("Missing auth token");

    const res = await fetch(`${serverHost}/create_extension`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
    });

    const data = await res.json();
    if (!res.ok) {
        throw new Error(data.error || "Failed to create extension");
    }

    return data;
}

// -----------------------
// Create Extensions (Bulk)
// -----------------------
export async function createExtensionsBulk(payload) {
    const token = getAuthToken();
    if (!token) throw new Error("Missing auth token");

    const res = await fetch(`${serverHost}/create_extensions_bulk`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (!res.ok) {
        throw new Error(data.error || "Failed to create extensions");
    }

    return data;
}


// -----------------------
// Get Extension
// -----------------------
export async function getExtension(extension_uuid) {
    const token = getAuthToken();
    if (!token) throw new Error("Missing auth token");

    const res = await fetch(`${serverHost}/get_extension/${extension_uuid}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    const data = await res.json();
    if (!res.ok) {
        throw new Error(data.error || "Failed to load extension");
    }

    return data;
}

// -----------------------
// Update Extension
// -----------------------
export async function updateExtension(extension_uuid, payload) {
    const token = getAuthToken();
    if (!token) throw new Error("Missing auth token");

    const res = await fetch(
        `${serverHost}/update_extension/${extension_uuid}`,
        {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
        }
    );

    const data = await res.json();
    if (!res.ok) {
        throw new Error(data.error || "Failed to update extension");
    }

    return data;
}

// -----------------------
// Delete Extension
// -----------------------
export async function deleteExtension(extension_uuid) {
    const token = getAuthToken();
    if (!token) throw new Error("Missing auth token");

    const res = await fetch(
        `${serverHost}/delete_extension/${extension_uuid}`,
        {
            method: "DELETE",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    const data = await res.json();
    if (!res.ok) {
        throw new Error(data.error || "Failed to delete extension");
    }

    return data;
}

// -----------------------
// Toggle Extensions (Bulk)
// -----------------------
export async function toggleExtensions(extensionUuids) {
    if (!Array.isArray(extensionUuids) || extensionUuids.length === 0) {
        throw new Error("extensionUuids must be a non-empty array");
    }

    const token = getAuthToken();
    if (!token) throw new Error("Missing auth token");

    const res = await fetch(`${serverHost}/toggle_extensions`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ extension_uuids: extensionUuids }),
    });

    const data = await res.json();
    if (!res.ok) {
        throw new Error(data.error || "Failed to toggle extensions");
    }

    return data;
}

export const getExtensionsSummary = async (siteUuid) => {
    const token = getAuthToken();
    if (!siteUuid) throw new Error("No site selected");

    const res = await fetch(`${serverHost}/dashboard/extensions_summary`, {
        headers: {
            Authorization: `Bearer ${token}`,
            "x-site-uuid": siteUuid,
        },
    });

    if (!res.ok) {
        throw new Error("Failed to fetch extensions summary");
    }

    return await res.json();
};

export const incrementAlpha = (str) => {
    if (!str) return "";

    const chars = str.split("");
    let i = chars.length - 1;

    while (i >= 0) {
        const c = chars[i];

        if (c >= "a" && c <= "y") {
            chars[i] = String.fromCharCode(c.charCodeAt(0) + 1);
            return chars.join("");
        }
        if (c === "z") {
            chars[i] = "a";
            i--;
            continue;
        }

        if (c >= "A" && c <= "Y") {
            chars[i] = String.fromCharCode(c.charCodeAt(0) + 1);
            return chars.join("");
        }
        if (c === "Z") {
            chars[i] = "A";
            i--;
            continue;
        }

        // non-letter → stop incrementing
        break;
    }

    return chars.join("");
};

export const generateVoicemailPassword = (length = 8) => {
    let result = "";
    for (let i = 0; i < length; i++) {
        result += Math.floor(Math.random() * 10);
    }
    return result;
};